



























import { SearchBuilder } from "@/builder";
import { useLocalFilter, useProduct } from "@/hooks";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { ProductPurchaseResponseDto } from "@/models/interface/ProductPurchaseResponse.interface";
import { PropType } from "vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

type Parameter = {
  branchId: string;
  productId: string;
  locationId?: string;
};

@Component
export default class SelectSnSales extends Vue {
  @Prop({ required: true, type: String, default: "" })
  value!: string;

  @Prop({ required: false, type: Boolean, default: false })
  disabled!: boolean;

  @Prop({ required: false, type: Object as PropType<Parameter> })
  parameter!: Parameter;

  useLocalFilter = useLocalFilter;

  options: Option<ProductPurchaseResponseDto>[] = [];
  loading = false;
  fetchSeq = 0;

  @Watch("parameter.branchId")
  onChangeBranch(): void {
    this.refetch();
  }

  @Watch("parameter.productId")
  onChangeProduct(): void {
    this.refetch();
  }

  @Watch("parameter.locationId")
  onChangeLocation(): void {
    this.refetch();
  }

  refetch(): void {
    const currentSeq = ++this.fetchSeq;
    this.options = [];
    if (!this.parameter?.branchId || !this.parameter?.productId) {
      this.loading = false;
      return;
    }

    const params = new RequestQueryParams();
    const builder = new SearchBuilder();
    const q: string[] = [
      builder.push(["branchWarehouseId", this.parameter.branchId]).build(),
    ];
    q.push(builder.push(["productId", this.parameter.productId]).build());
    // kalau lokasi terpilih, tampilkan hanya SN yang ada di lokasi tsb
    if (this.parameter.locationId) {
      q.push(builder.push(["locationId", this.parameter.locationId]).build());
    }
    params.search = q.join(builder.AND);
    this.fetchOptions(params, currentSeq);
  }

  fetchOptions(params: RequestQueryParams, currentSeq: number): void {
    const { findAllSnForSales } = useProduct();
    this.loading = true;
    findAllSnForSales(params)
      .then(res => {
        if (currentSeq !== this.fetchSeq) {
          return;
        }
        this.options = res.map((item, i) => ({
          label: item.serialNumber,
          value: item.serialNumber,
          key: i,
          meta: item,
        }));
      })
      .finally(() => {
        if (currentSeq === this.fetchSeq) {
          this.loading = false;
        }
      });
  }

  onChange(e: string): void {
    this.$emit("input", e);
    this.$emit("change", e);
    this.$emit("update:meta", this.findOption(e));
  }

  findOption(value: string): Option<ProductPurchaseResponseDto> | undefined {
    return this.options.find(e => value === e.value);
  }
}
